import { Button, IconButton } from '@mui/material';
import { PopoverTrigger } from 'src/components/PopoverTrigger';
import { Iconify } from 'src/components/iconify';
import { ChatThreadPopover } from 'src/sections/@dashboard/chat/ChatHeader/ChannelThreads/ChatThreadPopover';
import { useChatThreads } from 'src/sections/@dashboard/chat/ChatHeader/ChannelThreads/useChannelThreads';

type Props = {
  channelId: string;
  compact?: boolean;
};
export const ChannelThreads = ({ channelId, compact }: Props) => {
  const { refetch } = useChatThreads({ channelId });

  return (
    <PopoverTrigger
      popover={ChatThreadPopover}
      context={{ channelId }}
      onClick={() => refetch()}
    >
      {compact ? (
        <IconButton>
          <Iconify icon="tabler:timeline-event-text" />
        </IconButton>
      ) : (
        <Button
          sx={{ fontWeight: 'fontWeightRegular' }}
          startIcon={<Iconify icon="tabler:timeline-event-text" />}
        >
          Threads
        </Button>
      )}
    </PopoverTrigger>
  );
};
